import { Component, inject, signal } from '@angular/core';
import { form, FormField, required } from '@angular/forms/signals';
import { BaseDialogComponent } from '../../../../../../../components/kit/base-dialog/base-dialog.component';
import { DateInputComponent } from '../../../../../../../components/kit/input/date-input-v2/date-input.component';
import { ActionButtonsComponent } from '../../../../../../../components/kit/action-buttons/action-buttons.component';
import { successCreated } from '../../../../../content.error';
import { PlatformBillingInvoiceFormModel } from '../organization-platform-billing.types';
import { OrganizationPlatformBillingInvoiceCreateDialogStore } from './organization-platform-billing-invoice-create-dialog.store';

@Component({
    selector: 'app-organization-platform-billing-invoice-create-dialog',
    templateUrl: './organization-platform-billing-invoice-create-dialog.component.html',
    providers: [OrganizationPlatformBillingInvoiceCreateDialogStore],
    imports: [FormField, DateInputComponent, ActionButtonsComponent],
})
export class OrganizationPlatformBillingInvoiceCreateDialogComponent extends BaseDialogComponent {
    protected readonly store = inject(OrganizationPlatformBillingInvoiceCreateDialogStore);
    protected readonly organizationId = this.dialogConfig.data.organizationId as number;
    protected readonly numberSequenceId = this.dialogConfig.data.numberSequenceId as number | null;
    protected readonly prefix = 'organization.platformBilling.fields.';

    protected readonly formData = signal<PlatformBillingInvoiceFormModel>({
        periodFrom: null,
        periodTo: null,
    });
    protected readonly formDef = form(this.formData, (schema) => {
        required(schema.periodFrom);
        required(schema.periodTo);
    });

    public override async save(): Promise<void> {
        if (this.store.loadingAny()) return;
        if (this.formDef().invalid()) {
            this.formDef().markAsTouched();
            return;
        }

        const value = this.formData();
        const periodFrom = this.toDateString(value.periodFrom);
        const periodTo = this.toDateString(value.periodTo);
        if (this.numberSequenceId === null || !periodFrom || !periodTo) return;
        await this.store.api.createPlatformBillingInvoice({
            organizationId: this.organizationId,
            numberSequenceId: this.numberSequenceId,
            periodFrom,
            periodTo,
        });
        successCreated();
        this.dialogRef.close(true);
    }

    private toDateString(value: Date | null): string | null {
        if (!value) return null;
        const year = value.getFullYear();
        const month = String(value.getMonth() + 1).padStart(2, '0');
        const day = String(value.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }
}
